module.exports = {"welcome":"Willkommen <strong>%{name}</strong>","options":"Benutzeraktionen","logout":"abmelden"}